import { get } from 'lodash';

import { ASSET_TYPE, FIELD_PATHS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { SummaryStringDisplay } from '@funnels/ui-components';
import { Accordion, FunnelGrid, FunnelGridUnit } from '@funnels/ui-components/Common';
import { capitalizeForEnumValue, getApplicantsFullnameFromOwners } from '@funnels/utils';

interface AssetAccountDetailsSummaryProps {
  assetIndex: number;
  handleEditClick?: () => void;
}

export const AssetAccountDetailsSummary = ({ assetIndex, handleEditClick }: AssetAccountDetailsSummaryProps) => {
  const [formValues] = useFormValues();
  const applicants = get(formValues, FIELD_PATHS.APPLICANTS(), []);
  const asset = get(formValues, FIELD_PATHS.ASSET(assetIndex));
  const assetType: ASSET_TYPE = get({ assets: [asset] }, FIELD_PATHS.ASSET_TYPE(0));
  const assetTypeLabel = capitalizeForEnumValue(assetType);
  const assetOwners = get({ assets: [asset] }, FIELD_PATHS.ASSET_OWNERS(0), []);
  const ownerNames = getApplicantsFullnameFromOwners(assetOwners, applicants);

  return (
    <Accordion headerText="Account details" onPrimaryButtonClick={handleEditClick} primaryButtonLabel="Edit">
      <FunnelGrid>
        <FunnelGridUnit my="xs" size={1 / 2}>
          <SummaryStringDisplay title="Owner" value={ownerNames.join(' & ')} />
        </FunnelGridUnit>
        <FunnelGridUnit my="xs" size={1 / 2}>
          <SummaryStringDisplay title="Account type" value={assetTypeLabel} />
        </FunnelGridUnit>
        <FunnelGridUnit my="xs" size={1 / 2}>
          <SummaryStringDisplay
            title="Institution"
            value={get(formValues, FIELD_PATHS.ASSET_FINANCIAL_INSTITUTION(assetIndex))}
          />
        </FunnelGridUnit>
        <FunnelGridUnit my="xs" size={1 / 2}>
          <SummaryStringDisplay
            title="Balance"
            value={`$${get(formValues, FIELD_PATHS.ASSET_ESTIMATED_VALUE(assetIndex))}`}
          />
        </FunnelGridUnit>
        <FunnelGridUnit my="xs" size={1 / 2}>
          <SummaryStringDisplay title="BSB" value={get(formValues, FIELD_PATHS.ASSET_BSB(assetIndex))} />
        </FunnelGridUnit>
        <FunnelGridUnit my="xs" size={1 / 2}>
          <SummaryStringDisplay
            title="Account number"
            value={get(formValues, FIELD_PATHS.ASSET_ACCOUNT_NUMBER(assetIndex))}
          />
        </FunnelGridUnit>
      </FunnelGrid>
    </Accordion>
  );
};
